import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

const ResourcesPage = () => {
  const resources = [
    {
      title: 'Getting Started with VCRP',
      type: 'Guide',
      description: 'A comprehensive guide to help you set up and start using VCRP effectively.',
      image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'guide'
    },
    {
      title: 'Financial Management Best Practices',
      type: 'Whitepaper',
      description: 'Learn industry best practices for financial management and how to implement them in your business.',
      image: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'whitepaper'
    },
    {
      title: 'Supply Chain Optimization Webinar',
      type: 'Webinar',
      description: 'Watch our experts discuss strategies for optimizing your supply chain using VCRP.',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'webinar'
    },
    {
      title: 'HR Management Solution Overview',
      type: 'Video',
      description: 'A detailed walkthrough of our HR Management solution and its key features.',
      image: 'https://images.unsplash.com/photo-1516534775068-ba3e7458af70?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'video'
    },
    {
      title: 'Global Manufacturing Success Story',
      type: 'Case Study',
      description: 'How a leading manufacturer improved efficiency by 35% with VCRP.',
      image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'case-study'
    },
    {
      title: 'VCRP Implementation Roadmap',
      type: 'Guide',
      description: 'A step-by-step guide to successfully implementing VCRP in your organization.',
      image: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=300&q=80',
      category: 'guide'
    }
  ];

  return (
    <div className="bg-light py-5">
      <Container>
        <h1 className="text-center fw-bold mb-3">Resources</h1>
        <p className="text-center lead mb-5">Explore our library of guides, whitepapers, webinars, and more to help you get the most out of VCRP</p>
        
        {/* Search and Filter */}
        {/* <Row className="justify-content-center mb-5">
          <Col md={8} lg={6}>
            <InputGroup className="mb-3 shadow-sm">
              <Form.Control
                placeholder="Search resources..."
                aria-label="Search resources"
              />
              <Button variant="primary">
                Search
              </Button>
            </InputGroup>
          </Col>
        </Row> */}
        
        {/* Resource Categories */}
        {/* <Row className="justify-content-center mb-5">
          <Col xs="auto">
            <Button variant="outline-primary" className="me-2 mb-2">All</Button>
            <Button variant="outline-primary" className="me-2 mb-2">Guides</Button>
            <Button variant="outline-primary" className="me-2 mb-2">Whitepapers</Button>
            <Button variant="outline-primary" className="me-2 mb-2">Webinars</Button>
            <Button variant="outline-primary" className="me-2 mb-2">Videos</Button>
            <Button variant="outline-primary" className="mb-2">Case Studies</Button>
          </Col>
        </Row> */}
        
        {/* Resources Grid */}
        <Row xs={1} md={2} lg={3} className="g-4">
          {resources.map((resource, idx) => (
            <Col key={idx}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Img variant="top" src={resource.image} />
                <Card.Body>
                  <div className="mb-2">
                    <span className="badge bg-primary">{resource.type}</span>
                  </div>
                  <Card.Title className="fw-bold">{resource.title}</Card.Title>
                  <Card.Text>{resource.description}</Card.Text>
                </Card.Body>
               
              </Card>
            </Col>
          ))}
        </Row>
        
        {/* Newsletter Signup */}
        {/* <Row className="justify-content-center mt-5">
          <Col md={10} lg={8}>
            <Card className="border-0 shadow-sm bg-primary text-white">
              <Card.Body className="p-4 text-center">
                <h2 className="fw-bold mb-3">Stay Updated</h2>
                <p className="mb-4">Subscribe to our newsletter for the latest resources, tips, and product updates</p>
                <Row className="justify-content-center">
                  <Col md={8}>
                    <InputGroup>
                      <Form.Control
                        placeholder="Enter your email address"
                        aria-label="Email address"
                      />
                      <Button variant="light">Subscribe</Button>
                    </InputGroup>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default ResourcesPage;
